import { Navigate } from "react-router-dom";
import { getToken } from './Common';

function PrivateRoute({ children }) {
  return getToken() ? children : <Navigate to="/" replace />;
}

export default PrivateRoute;